/**
 * Route for `auto-block-publisher-when-fraud-threshold-hit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoBlockPublisherWhenFraudThresholdHitPage } from "../features/auto-block-publisher-when-fraud-threshold-hit/AutoBlockPublisherWhenFraudThresholdHitPage";

export const autoBlockPublisherWhenFraudThresholdHitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-block-publisher-when-fraud-threshold-hit",
	component: AutoBlockPublisherWhenFraudThresholdHitPage,
});

export default autoBlockPublisherWhenFraudThresholdHitRoute;
